import { RouteObject } from "react-router-dom";
import { PricingCalculator } from "@/components/pages/Embed";
import { SubscriptionPlan } from "@/components/pages/SubscriptionPlan/SubscriptionPlan";
import { Embed } from "@/containers";

/**
 * Routes for embeddable pages
 * These pages are designed to be embedded via iframe on external websites
 * They do not require authentication
 */
export const embedRoutes: RouteObject = {
  path: "embed",
  element: <Embed />,
  children: [
    {
      path: "pricing-calculator",
      element: <PricingCalculator />,
    },
    {
      path: "subscription-plan",
      element: <SubscriptionPlan />,
    },
  ],
};
